import React from "react";
import Header from "../../components/Header/Header";
import NavBar from "../../components/NavBar/NavBar";
import { Box } from "@mui/material";

import "./Consultant.css";

function Consultant() {
  return (
    <div className="CommingSoon">
      <Header />
      <NavBar />
      <Box
        style={{
          display: "flex",
          flexDirection:'column',
          justifyContent: "center",
          alignItems: "center",
          height: "70vh", // Adjust this value based on your needs
          marginTop:'15%'
        }}
      >
        <video width="750" height="500" autoPlay loop  playsInline preload>
          <source
            src="https://static-media.dawaai.pk/doctor-consultation.mp4"
            type="video/mp4"
          />
        </video>
        <Box sx={{ display: 'flex', flexDirection: 'row', width: '80%', justifyContent: 'center', gap: '5%', alignItems: 'center', marginBottom: '10%', marginTop: '12%' }}>
  <img style={{ height: '100%', width: '40%' }} class="img-responsive" src="https://static-media.dawaai.pk/img/doctor-consults/tele-banner3.png" alt="hjsus" />
  <img style={{ height: '100%', width: '40%' }} class="img-responsive" src="https://static-media.dawaai.pk/img/doctor-consults/tele-banner2.png" alt="jss" />
</Box>
      </Box>
    

    </div>
  );
}

export default Consultant;
